
/* Aasraa Product Configuration V1 */

(() => {
  function initPicker(picker) {
    if (picker.dataset.aasraaCardsReady === "true") return;

    const dataElement = picker.querySelector(
      'script[type="application/json"]'
    );
    if (!dataElement) return;

    let variants;
    try {
      variants = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    if (!Array.isArray(variants)) return;

    picker.dataset.aasraaCardsReady = "true";
    picker.classList.add("aasraa-variant-cards");

    const fieldsets = Array.from(
      picker.querySelectorAll("fieldset")
    );

    function getSelections() {
      return fieldsets.map((fieldset) => {
        return fieldset.querySelector(
          'input[type="radio"]:checked'
        )?.value || null;
      });
    }

    function formatPrice(cents) {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0
      }).format(cents / 100);
    }

    function updateCards() {
      const selections = getSelections();

      fieldsets.forEach((fieldset, optionIndex) => {
        const optionName = fieldset
          .querySelector("legend")
          ?.textContent.trim().toLowerCase() || "";

        const showPrices = [
          "battery", "batteries", "wheel", "wheels",
          "wheel type", "tyre", "tyres", "size",
          "seat width"
        ].includes(optionName);

        const radios = Array.from(
          fieldset.querySelectorAll('input[type="radio"]')
        );

        radios.forEach((radio) => {
          const label = Array.from(
            fieldset.querySelectorAll("label")
          ).find((item) => item.htmlFor === radio.id);

          if (!label) return;

          const matches = variants.filter((variant) => {
            return selections.every((selected, index) => {
              if (index === optionIndex) {
                return variant.options[index] === radio.value;
              }
              return !selected ||
                variant.options[index] === selected;
            });
          });

          const available = matches.find(
            (variant) => variant.available
          );

          const matchingVariant = available || matches[0];

          if (showPrices &&
              !label.classList.contains("swatch-variant-image") &&
              !label.classList.contains("swatch-variant-color")) {

            let priceElement = label.querySelector(
              ".aasraa-option-price"
            );

            if (!priceElement) {
              priceElement = document.createElement("span");
              priceElement.className = "aasraa-option-price";
              label.appendChild(priceElement);
            }

            priceElement.textContent = matchingVariant
              ? formatPrice(matchingVariant.price)
              : "Unavailable";
          }

          label.classList.toggle(
            "aasraa-option-unavailable",
            !available
          );
        });
      });
    }

    picker.addEventListener("change", updateCards);
    updateCards();
  }

  function initAll() {
    document.querySelectorAll(
      ".product__info-container variant-radios"
    ).forEach(initPicker);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener(
    "shopify:section:load",
    initAll
  );
})();
